module.exports = __webpack_public_path__ + "static/media/B_F02.dd08c7a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/B_F02.png
// module id = 116
// module chunks = 0